module.exports = __webpack_public_path__ + "assets/img/0deb1b0ebbf6b00bd567e9a2e9de58cc.webp";